import { Component, inject, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavMenuService } from '@custom-header/services/nav-menu.service';
import { ICON_TYPE, NavigationNode } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';

@Component({
  selector: 'custom-cx-nagivation-ui',
  standalone: false,
  templateUrl: './custom-cx-nagivation-ui.component.html',
  styleUrls: ['./custom-cx-nagivation-ui.component.scss'],
})
export class CustomCxNagivationUiComponent {
  iconType = ICON_TYPE;

  /**
   * The navigation node to render.
   */
  @Input() node!: NavigationNode | null;

  constructor(
    protected userAccountFacade: UserAccountFacade,
    private router: Router,
  ) {}

   navMenuService = inject(NavMenuService);

  isMenuCollapsed = this.navMenuService.isMenuCollapsed;

  toggleNav() {
    this.navMenuService.toggle();
  }

  closeMenu() {
    this.navMenuService.close();
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.navMenuService.close();
      }
    });
  }
}
